import * as Config from '../../config';
import { default as Locale } from '../../utils/Locale';
import * as UUID from '../../utils/Uuid';
import { AlertInfo, AlertType, AlertRecord, AlertCategories } from "../Types";
import { AlertLogic } from './AlertLogic';
import { ContentCategories } from "../../types";


export class PumpInterlockedDueToWaterLevelSensor extends AlertLogic {
    static type = AlertType.PumpInterlockedDueToWaterLevelSensor;
    static category = AlertCategories.OTHER;
    static contentCategories = [ ContentCategories.WATER_FLOW ];
    static title = Locale.gettext('PumpInterlockedDueToWaterLevelSensor');

    getInfo(alert: AlertRecord = this.alert, config: Config.AllConfig = this.allConfigs): AlertInfo {
        const { body, device: pumpConfig, alertData, firstReported } = this.getCommons(alert, config);
            
        const waterLevelSensorConfigs = config?.Config?.Devices?.filter(item =>
            (alertData?.WaterLevelSensorUUIDs || []).includes(item.UUID)
        );

        const alertInfo = AlertInfo.fromCardConfig({
            cardTitle: this.locale.gettext("Pump Disabled"),
            cardDescription: this.locale.gettext("Interlocked pump %1$s is prevented from running",
                pumpConfig.Name
            ),
            cardIllustration: "report_warning",
            detailIcon: "pump",
            detailDescription: this.locale.gettext("%1$s has been disabled and will not run because the following water level sensor(s) are reporting a problem:\n\n%2$s",
                pumpConfig.Name,
                (waterLevelSensorConfigs || []).map(item => item.Name).join("\n")
            ),
            detailDescription2: this.locale.gettext("The pump will not run again until the water level has normalized."),
        });
        alertInfo.contentCategories = PumpInterlockedDueToWaterLevelSensor.contentCategories;
        return alertInfo;
    } 

    static mock(type:AlertType, config:Config.AllConfig):AlertRecord {
        const device = config.Config.Devices?.find(item => item.DeviceType === Config.DeviceTypes.PUMP);
        const WaterLevelSensorUUIDs = config.Config?.Devices?.find(itemWaterLevelSensor => 
            itemWaterLevelSensor.DeviceType === Config.DeviceTypes.WATERLEVELSENSOR &&
            itemWaterLevelSensor.HardwareDevice?.WaterLevelSensorSettings?.InterlockedPumps?.some(item => item.UUID === device.UUID)
        );

        return device ? new AlertRecord({
            id: Math.floor(Math.random() * 100000),
            uuid: UUID.modifySection(4, UUID.modifySection(3, device.UUID, "MOCK"), "ALRT" + type),
            siteId: Math.floor(Math.random() * 100000),
            deviceId: 1,
            entityUuid: device.UUID,
            bodyUuid: undefined,
            type,
            data: {
                WaterLevelSensorUUIDs
            }
        }) : null;
    }
}
